import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/header-img.png";
import carInsuranceImg from "../assets/img/car-insurance.png";
import nnwInsuranceImg from "../assets/img/education.png";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Banner = (props) => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const toRotate = ["komunikacyjne", "dla firm", "majątkowe"];
  const period = 2000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => { clearInterval(ticker) };
  }, [text])

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex(prevIndex => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex(prevIndex => prevIndex + 1);
    }
  }

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <span className="tagline">Polisa szybko i tanio!</span>
                  <h1>{`Ubezpieczenia`} <br></br><span className="txt-rotate" dataPeriod="1000" data-rotate='[ "komunikacyjne", "dla firm", "majątkowe" ]'><span className="wrap">{text}</span></span></h1>
                  <p>Przyjdź do nas po bezpłatną kalkulację - z naszymi zniżkami zapłacisz taniej. Pozwól zaoszczędzić sobie czas i pieniądze.</p>

                  <button onClick={props.togglevehicleBool}>Poznaj w 24H najlepszą ofertę <ArrowRightCircle size={25} /></button>

                </div>}
            </TrackVisibility><br></br><br></br>
            <Col xs={12} md={6} xl={5}><p>Wybierz ubezpieczenie:</p>
              <div>                  <img src={carInsuranceImg} className={"insurance-img"} onClick={props.togglevehicleBool} />
                <img src={nnwInsuranceImg} className={"insurance-img"} onClick={props.toggleNNWBool} /></div></Col>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img className="imgupdown" src={headerImg} alt="Header Img" />
                </div>}
            </TrackVisibility>
          </Col>
        </Row>

      </Container>
    </section>
  )
}
